<template>
  <div style="height:100%">
    <div class="topLeft">
      <el-card shadow="never" class="inner-card">
        <el-carousel class="height-full" v-if="pictureList.length>0">
          <el-carousel-item v-for="item in pictureList" :key="item.id">
            <el-image class="el-image" :src="downloadUrl(prjInfo.prjId,item.fileId)"> </el-image>
          </el-carousel-item>
        </el-carousel>
        <el-image class="el-image" :src="noProjectImage" v-else> </el-image>
      </el-card>
      <component :is="cardRender"></component>
    </div>
    <el-card shadow="never" class="topRight" >
      <div class="message__container">
        <message :prjId="prjId"></message>
      </div>
    </el-card>
    <div class="plan-card" v-loading="planLoading">
      <div class="plan-header">
        计划
        <div class="append" ref="append"></div>
      </div>
      <div class="plan-com" v-if="planLoaded">
        <plan :propConPlanId="propConPlanId" @hook:mounted="afterPlanMounted" ref="plan" :propConPlanName="propConPlanName">
        </plan>
      </div>
      <div class="plan-com" style="display:grid;place-content:center;" v-else>
        <img :src="require('@/CommonDP/assets/enterprise/kongqiye.png')"/>
      </div>
    </div>
    <el-dialog v-dialogDrag :visible.sync="projectImageVisible" :close-on-click-modal="false" :close-on-press-escape="false" :before-close="projectImageClose" title="项目图片" width="40%">
      <div class="dialog">
        <div v-for="item in pictureList" :key="item.id" class="dialogImg" >
          <el-image class="img" :src="downloadUrl(prjInfo.prjId,item.fileId)"/>
          <img :src="deletePic" alt="删除图片" class="deleteIcon" @click="deletePictre(item.id)" >
        </div>
        <el-upload  ref="upload" list-type="picture-card" action="/" :http-request="uploadPictureInfo" v-if="pictureList.length<5"
          class="avatarUploader" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload" :limit="5" accept=".jpg,.jpeg,.png,.JPG,.JPEG,.PNG">
          <img :src="addPic" class="jia" alt="添加图片">
        </el-upload>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" type="primary" @click="projectImageClose" >关闭</el-button >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import project from "@/CommonDP/service/project-service";
import projectHome from "@/xgzdService/projectHome-service";
import majorProportion from "./majorProportion.vue"
import reviewProportion from "./reviewProportion.vue"
import problemType from "./problemType.vue"
import plan from '@/views/project/task/list.vue'
import { downloadUrl } from "@/utils";
import { checkPermission } from "@/utils/routeAuth"
import { mapState } from "vuex";
import message from '@/views/workbench/message.vue'
import bimService from "@/xgzdService/buildPlan-service"
export default {
  components:{ majorProportion , message, reviewProportion ,problemType, plan},
  props: {
    visible: { type: Boolean, default: false}
  },
  data(){
    return{
      pictureList:[],
      modelInfoName: "info",
      prjInfoDetail:{},
      // projectImageVisible:false, 
      addPic:require(`@/views/assets/addPic.png`),
      deletePic:require(`@/views/assets/deletePic.png`),
      noProjectImage:require(`@/views/assets/projectNo.png`),
      radio:1,
      activeName:"first",
      reviewList:[],
      peopleName:["审图总人数","内部参审人数","外部参审人数"],
      uploadImage: checkPermission('projectHome:upload'),
      planLoaded: false,
      planLoading: false,
      propConPlanId: null,
      propConPlanName: null
    }
  },
  computed: {
    ...mapState({
      prjInfo: state => state.projectMg.prjObj,
      prjId: state => state.projectMg.prjObj?.prjId,
      enterpriseId: state => state.enterprise.enterpriseId,
    }),
    cardRender() {
      const _this = this
      return {
        render() {
          return _this.cardRenderImpl()
        }
      }
    },
    projectImageVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible',val)
      }
    }
  },
  watch:{
    prjInfo: {
      deep: true,
      handler: function({ prjId }, oldValue) {
        if (prjId) {
          this.getDetail();
          this.getFileList();
        }
      }
    }
  },
  mounted(){
    this.getDetail();
    this.getFileList();
    this.getReviewNum();
    this.getPlanInfo()
  },
  methods:{
    afterPlanMounted() {
      const input = this.$refs.plan?.$refs?.taskInput
      if (input) {
        this.$refs.append.appendChild(input.$el)
      }
    },
    // 获取初始计划
    async getPlanInfo() {
      const { enterpriseId,prjId } = this;
      const params = {
        pageSize:1,
        pageNum: 1,
        enterpriseId,
        prjId,
        isHomePageShow:1
      }
      this.planLoading = true
      const res = await bimService.getConstructionPlan(params).catch(err => {
        console.error('获取计划信息失败')
      })
      this.planLoading = false
      if(Array.isArray(res?.data) && res.data.length >= 1) {
        this.propConPlanId = res.data[0]?.conPlanId
        this.propConPlanName = res.data[0]?.conPlanName
        this.planLoaded = true
      }

    },
    cardRenderImpl() {
      const props = [
        ['项目名称', 'prjName'],
        ['所属城市', 'provinceCity'],
        ['总用地面积', 'totalLandArea', '㎡'],
        ['总建筑面积', 'grossFloorArea', '㎡'],
        ['项目类型', 'prjCategory'],
        ['项目等级', 'prjLevel']
      ]
      const target = this.prjInfoDetail
      // 无效属性过滤
      const isUnvalid = (val) => !val && val !== 0
      const prjNameRender = () => {
        return <div class="prjName__wrapper">
                  <p> <span class="label">项目名称</span></p>
                  <p> <span class="label-value">{target['prjName']}</span></p>
          </div>
      }
      return <div class="inner-prop__container"> {
        props.filter(item => !isUnvalid(target[item[1]])).map(
          item =>
                item[1] === 'prjName' ?
                prjNameRender()
                :
                (<p>
                <span class="label">{ item[0]}：</span>
                <span class="label-value" title={target[item[1]]}>
                  { target[item[1]]}{item[2] || ''}</span>
                </p>)
        )
      }
      </div>
    },
    async getReviewNum(){
      const {prjInfo:{prjId},enterpriseId}=this;
      const { data } =await projectHome.getDrawingReviewNum(prjId,enterpriseId);
      this.reviewList = data.map((item,index)=>{
        return {
          num:item,
          image:require(`@/views/assets/people${index}.png`),
          peopleName:this.peopleName[index]
        }
      });
    },
    timeEvent(index) {
      this.radio = index;
      this.$refs.problemType.getSpecCount()
    },
    downloadUrl,
    async getDetail(){
      const { data } =await project.viewList(this.prjInfo.prjId);
      this.prjInfoDetail = data;
    },
    projectImageAdd(){
      this.getFileList();
      this.projectImageVisible=true;
    },
    projectImageClose(){
      this.projectImageVisible=false;
    },
    // 上传图片 ，返回对应文件id
    async uploadPictureInfo(req) {
      const {prjId }=this.prjInfo;
      const {folderId}=this.prjInfoDetail;
      const form = new FormData();
      form.append("file", req.file);
      return await  projectHome.projectUpload(form,prjId,folderId);
    },
    handleAvatarSuccess(res, file) {
      this.relationprjFile(res.data.fileId)
    },
    //将文件id与项目关联
    async relationprjFile(fileId){
      const { prjId }=this.prjInfo;
      const params={
        prjId,
        fileId,
        source:0
      };
      await projectHome.prjInfoFileIdRela(params);
      await this.getFileList();
    },
    //获取文件列表
    async getFileList(){
      const { prjId }=this.prjInfo;
      const {data} =await projectHome.getFileIdList(prjId,0);
      this.pictureList=data;
    },
    beforeAvatarUpload(file) {
      let isJPG = this.isImage(file.name);
      const isLt5M = file.size / 1024 / 1024 < 5;
      if (!isJPG) {
        this.$message.error("上传项目图片只能是 JPG或PNG 格式!");
      }
      if (!isLt5M) {
        this.$message.error("上传项目图片大小不能超过 5M!");
      }
      return isJPG && isLt5M;
    },
    isImage(fileName) {
      if (typeof fileName !== 'string') return;
      let name = fileName.toLowerCase();
      return name.endsWith('.png') || name.endsWith('.jpeg') || name.endsWith('.jpg') || name.endsWith('.png') || name.endsWith('.bmp');
    },
    async deletePictre(id){
      await this.$confirm(`您确定要删除这张图片吗`, "警告", { type: "warning" });
      await projectHome.projectfilIdDelete(id);
      await this.getFileList();
    }
  }
}
</script>

<style lang="scss" scoped src="./home.scss"/>